import { render, staticRenderFns } from "./TradingInformation.vue?vue&type=template&id=2531deae&scoped=true"
import script from "./TradingInformation.vue?vue&type=script&lang=js"
export * from "./TradingInformation.vue?vue&type=script&lang=js"
import style0 from "./TradingInformation.vue?vue&type=style&index=0&id=2531deae&prod&lang=scss&scoped=true"
import style1 from "./TradingInformation.vue?vue&type=style&index=1&id=2531deae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531deae",
  null
  
)

export default component.exports